"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingService = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
let LoadingService = class LoadingService {
    constructor() {
        this.incrementalProgress = false;
    }
    start(message) {
        this.message = message;
        this.loading = true;
    }
    stop() {
        this.message = "";
        this.loading = false;
        this.incrementalProgress = false;
    }
    status() {
        return this.loading;
    }
    startProgress(total, message) {
        this.message = message;
        this.incrementalProgress = true;
        this.loadTotal = total;
        this.loadCurrent = 1;
        this.start(message);
    }
    progress(message) {
        this.message = message;
        this.loadCurrent++;
        if (this.loadCurrent == this.loadTotal) {
            this.stop();
            this.incrementalProgress = false;
        }
    }
    getMessage() {
        return this.message;
    }
    current() {
        return this.loadCurrent;
    }
    total() {
        return this.loadTotal;
    }
    showProgress() {
        return this.incrementalProgress;
    }
};
exports.LoadingService = LoadingService;
exports.LoadingService = LoadingService = __decorate([
    (0, core_1.Injectable)()
], LoadingService);
//# sourceMappingURL=loading.service.js.map